var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcr-nav-bar"},[_c('vcr-logo'),_vm._v(" "),_c('vcr-nav-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }